import { IItemTagState } from '@/store/item-tag';
import { IItemTagGetters } from './getters.types';
import { ITag, Tag } from '@/models';

export const getters: IItemTagGetters = {
  getTags(state: IItemTagState): ITag[] {
    return state.tags.map(data => new Tag(data));
  },

  getTagById: (state: IItemTagState) => (id: number): ITag | undefined => {
    const data = state.tags.find(tag => tag.id === id);
    if (!data) {
      return undefined;
    }

    return new Tag(data);
  }
};
